<template>
  <h4 v-if="requests.length === 0">Загрузите заявки</h4>
  <div v-else style="width: 100%; height: 1500px; overflow: auto">
    <table class="table">
      <thead>
      <tr>
        <th>#</th>
        <th>Действие</th>
        <th>ФИО</th>
        <th>Телефон</th>
        <th>Номер договора</th>
        <th>Комментарий</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(r, idx) in requests" :key="r._id">
        <td>{{idx + 1}}</td>
        <td>
          <router-link v-slot="{navigate}" custom :to="{name: 'Request', params: {id: r._id}}">
            <button class="btn primary" @click="navigate">Открыть</button>
          </router-link>
        </td>
        <td>{{ r.name }}</td>
        <td>{{ r.phone }}</td>
        <td>{{ r.contract }}</td>
        <td>{{ r.message }}</td>
      </tr>
      </tbody>
    </table>
  </div>

</template>

<script>
export default {
  props: ['requests']
}
</script>

<style scoped>
button {
  margin: 10px;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  overflow: auto;
}

.table th {
  padding: .5rem 1rem;
}

.table td {
  padding: .5rem 1rem;
}

.table tbody td {
  text-align: center;
}

.table tbody tr:hover {
  background: #eee;
}

</style>